import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface ModalData {
  type: 'risk' | 'export' | 'info';
  data?: any;
}

@Injectable({
  providedIn: 'root'
})
export class ModalService {
  private modalSubject = new Subject<ModalData>();
  public modal$ = this.modalSubject.asObservable();

    showRiskModal(data: any) {
    this.modalSubject.next({
      type: 'risk',
      data
    });
  }

  showExportModal(data: any) {
    this.modalSubject.next({
      type: 'export',
      data
    });
  }

  showInfoModal(data: any) {
    this.modalSubject.next({
      type: 'info',
      data
    });
  }
}